// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__NARe7","empty":"ModalGraph_empty__3XpXq"};